// import React, { useEffect, useState } from "react";
// import { useParams,useNavigate } from "react-router-dom";
// import { useAuth } from "../../components/auth/AuthRequiredRoute/AuthRequiredRoute";
// import { useLoanInfo } from "../../features/loans/hooks/useLoanInfo";
// import HeaderComponent from "../Header/HeaderComponent";
// import HeaderDesktop from "../Header/HeaderDesktop";
// import styles from "./DownloadLoanContractPage.module.css";
// import { ArrowDown } from "lucide-react";
// import { useIsDesktop } from "../../hooks/useIsDesktop";
// import { useTranslation } from "react-i18next";
// import { DownloadAttachment } from "../../services/modules/loan";

// const DownloadLoanContractPage = () => {
//   const navigate = useNavigate();

//   const { loanId } = useParams();
//   const { t, i18n } = useTranslation('downloadContract');
//   const { userData } = useAuth();
//   const [previewUrl, setPreviewUrl] = useState(null);
//   const { loanInfo } = useLoanInfo({ loanId, userData });
  
//   const isDesktop = useIsDesktop();

//   const handleDownload = async () => {
//     const isLineBrowser = /Line\/[0-9.]+/.test(navigator.userAgent);
//     // test
//     const pathAndQuery = window.location.pathname + window.location.search
//     console.log("pathAndQuery", pathAndQuery);
//     const externalUrl = `intent://${window.location.host}${pathAndQuery}#Intent;scheme=https;package=com.android.chrome;end`;
//     console.log("externalUrl", externalUrl);

//     if (isLineBrowser) {
//       // const currentUrl = window.location.origin + `/my-loan-contract/${loanId}?download=true`;
//       // window.location.href = `intent://${currentUrl.replace(/^https?:\/\//, '')}#Intent;scheme=https;package=com.android.chrome;end`;
//       const pathAndQuery = window.location.pathname + window.location.search;
//       const externalUrl = `intent://${window.location.host}${pathAndQuery}#Intent;scheme=https;package=com.android.chrome;end`;

//       window.location.href = externalUrl;
//       return;
//     }

//     try {
//       const body = {
//         loan_id: Number(loanId),
//         file_name: "contract",
//       };

//       const blobUrl = await DownloadAttachment({ body });
//       const link = document.createElement("a");
//       link.href = blobUrl;
//       link.download = "loan-contract.pdf";
//       document.body.appendChild(link);
//       link.click();
//       document.body.removeChild(link);

//       setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
//     } catch (error) {
//       console.error("Download failed", error);
//     }
//   };


// useEffect(() => {
//   const fetchContract = async () => {
//     try {
//       const body = {
//         loan_id: Number(loanId),
//         file_name: "contract",
//       };
//       const blobUrl = await DownloadAttachment({ body });
//       setPreviewUrl(blobUrl);
//       const urlParams = new URLSearchParams(window.location.search);
//       if (urlParams.get("download") === "true") {
//         // auto download when redirected from intent
//         const link = document.createElement("a");
//         link.href = blobUrl;
//         link.download = "loan-contract.pdf";
//         document.body.appendChild(link);
//         link.click();
//         document.body.removeChild(link);

//         setTimeout(() => URL.revokeObjectURL(blobUrl), 1000);
//       }
//     } catch (error) {
//       console.error("Preview failed", error);
//     }
//   };

//   if (loanId) {
//     fetchContract();
//   }
// }, [loanId]);


//   return (
//     <div className={styles.pageBg}>
//       {isDesktop ? (
//                 <HeaderDesktop title={t('header')} showIcon={true} onBack={true} />
//               ) : (
//                 <HeaderComponent title={t('header')} onBack={() => {navigate(`/my-loans/${loanId}`);
// }} />
//               )}      
//       <div className={styles.content}>
//         <p className={styles.loanNo}>{t('loanId')} {loanInfo?.loan_name}</p>
//         {previewUrl ? (
//           <div className={styles.contractSection}>
//             {isDesktop ? (
//               <embed className={styles.pdf} src={previewUrl} type="application/pdf" />
//             ) : (
//               <canvas id="pdf-canvas" style={{ width: "100%" }} />
//             )}
//           </div>
//         ) : (
//           <p>{t('loading')}</p>
//         )}
//         <button onClick={handleDownload} className={styles.downloadBtn}>
//           <span className={styles.downloadIcon}>
//             <ArrowDown />
//           </span>{" "}
//           {t('download')}
//         </button>
//       </div>
//     </div>
//   );
// };

// export default DownloadLoanContractPage;

import React, { useEffect, useState } from "react";
import { useParams,useNavigate } from "react-router-dom";
import { useAuth } from "../../components/auth/AuthRequiredRoute/AuthRequiredRoute";
import { useLoanInfo } from "../../features/loans/hooks/useLoanInfo";
import HeaderComponent from "../Header/HeaderComponent";
import HeaderDesktop from "../Header/HeaderDesktop";
import styles from "./DownloadLoanContractPage.module.css";
import { ArrowDown } from "lucide-react";
import { useIsDesktop } from "../../hooks/useIsDesktop";
import { useTranslation } from "react-i18next";
import { DownloadAttachmentContract } from "../../services/modules/loan";
const DownloadLoanContractPage = () => {
  const navigate = useNavigate();

  const { loanId } = useParams();
  const { t, i18n } = useTranslation('downloadContract');
  const { userData } = useAuth();
  const [previewUrl, setPreviewUrl] = useState(null);

  const { loanInfo } = useLoanInfo({ loanId, userData });
  
  const isDesktop = useIsDesktop();

  const handleDownload = async () => {
  const isLineBrowser = /Line\/[0-9.]+/.test(navigator.userAgent);

 if (isLineBrowser) {
  // Redirect to external browser (Safari for iOS, Chrome for Android)
  const pathAndQuery = window.location.pathname + window.location.search;
  const host = 'auunjai.com'; // Development host
  const baseUrl = `https://${host}${pathAndQuery}?openExternalBrowser=1`;

  // Detect platform (iOS or Android)
  const isIOS = /iPhone|iPad|iPod/i.test(navigator.userAgent);
  const isAndroid = /Android/i.test(navigator.userAgent);

  let externalUrl;

  if (isAndroid) {
    // Android: Use intent URL to open in Chrome
    externalUrl = `intent://${host}${pathAndQuery}#Intent;scheme=https;package=com.android.chrome;end`;
  } else if (isIOS) {
    const userConfirmed = window.confirm(
      'This page works better in Safari. Would you like to open it in Safari now?'
    );
    if (userConfirmed) {
      window.location.href = baseUrl;
    }
  } else {
    window.location.href = baseUrl;
  }

  window.location.href = externalUrl;
  return;
}

  try {
    const body = {
      loan_id: Number(loanId),
      file_name: "contract",
    };

    const blob = await DownloadAttachmentContract({ body });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = "loan-contract.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => URL.revokeObjectURL(url), 1000);

  } catch (error) {
    console.error("Download failed", error);
  }
};



useEffect(() => {
  const fetchContract = async () => {
    try {
      const body = {
        loan_id: Number(loanId),
        file_name: "contract",
      };
      const blob = await DownloadAttachmentContract({ body });
      const blobUrl = URL.createObjectURL(blob);
      setPreviewUrl(blobUrl);

    } catch (error) {
      console.error("Preview failed", error);
    }
  };

  if (loanId) {
    fetchContract();
  }
}, [loanId]);

  return (
    <div className={styles.pageBg}>
      {isDesktop ? (
                <HeaderDesktop title={t('header')} showIcon={true} onBack={true} />
              ) : (
                <HeaderComponent title={t('header')} onBack={() => {navigate(`/my-loans/${loanId}`);
}} />
              )}      
      <div className={styles.content}>
        <p className={styles.loanNo}>{t('loanId')} {loanInfo?.loan_name}</p>
        {isDesktop && (
          previewUrl ? (
            <div className={styles.contractSection}>
              <embed className={styles.pdf} src={previewUrl} type="application/pdf" />
            </div>
          ) : (
            <p>{t('loading')}</p>
          )
        )}

        <button onClick={handleDownload} className={styles.downloadBtn}>
          <span className={styles.downloadIcon}>
            <ArrowDown />
          </span>{" "}
          {t('download')}
        </button>
      </div>
    </div>
  );
};

export default DownloadLoanContractPage;
